<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <h3>About Page Content</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="aboutContentForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-8 form-div">
                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Blog description is required.',
                    }"
                  >
                    <!-- <vue-editor
                      placeholder="Storytime content..."
                      :class="errors[0] ? 'error-outline' : ''"
                      v-model="form.storyContent"
                    ></vue-editor> -->
                    <ckeditor
                      v-model="form.storyContent"
                      :config="editorConfig"
                      :error-messages="errors[0]"
                    ></ckeditor>
                    <span class="form-errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Video title is required.',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.videoTitle"
                      :error-messages="errors[0]"
                      label="Video Title"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal" class="view-current-video">
                  <a v-if="old_video" :href="old_video" target="_blank"
                    ><strong>View Current Video <b-icon icon="arrow-right"></b-icon></strong></a
                  >
                  <vue-dropzone
                    name="aboutVideo"
                    ref="aboutVideoUpload"
                    id="example-input-0 dropzone"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="(file) => uploadFile(file)"
                    @vdropzone-removed-file="dropzoneFileRemoved"
                    v-on:vdropzone-total-upload-progress="videoUploadProgress"
                    v-on:vdropzone-sending="appendFormData"
                    aria-describedby="input-0-live-feedback"
                  >
                    <div class="dropzone dropzone-default" id="kt_dropzone_1">
                      <div class="dropzone-msg dz-message needsclick">
                        <h4>Please upload Video</h4>
                        <h5>Drop your file here or click to upload</h5>
                        <p>
                          Allowed format: AVI, MKV, MP4, WMV, MOV
                          <br />Maximum upload size: 100MB
                        </p>
                      </div>
                    </div>
                  </vue-dropzone>
                </b-form-group>

                <div
                  class="loader-bar text-left"
                  v-if="totaluploadprogress > 0"
                >
                  <h5>
                    Video Uploading Progress : ({{
                      parseInt(totaluploadprogress)
                    }}%)
                  </h5>
                    <v-progress-linear
                      color="light-blue"
                      height="10"
                      :value="totaluploadprogress"
                      striped
                    ></v-progress-linear>
                    <!-- <div
                      class="progress-bar progress-bar-striped"
                      role="progressbar"
                      :style="'width: ' + totaluploadprogress + '%'"
                      aria-valuenow="10"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div> -->
                </div>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="handleCancel">
                    Cancel
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                  <!-- <br />
              <span class="form-errors" v-if="formError"
                >One or more fields has error. Please check form again.</span
              > -->
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="about" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import moment from "moment";
import { VueEditor, Quill } from "vue2-editor";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";
import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);

Vue.use(Notifications);
export default {
  name: "AboutContent",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("local_products_user_access_id");
      this.editAboutContent();
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    // VueEditor,
  },
  data() {
    return {
      totaluploadprogress: 0,
      dropzoneOptions: {
        url: "http://178.62.42.159/book-your-room-api/api/v1/add-about-us-content",
        thumbnailWidth: 150,
        maxFilesize: 100,
        maxFiles: 1,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 50000000,
        acceptedFiles: ".mp4, .wmv, .mov, .mkv, .avi",
        uploadMultiple: false,
        headers: { Authorization: `Bearer ${JwtService.getToken()}` },
        success: this.videoUploadSuccess,
      },
      submitText: "Submit",
      disabledDates: {
        ranges: [],
      },
      formError: false,
      userId: null,
      btnDisable: false,
      old_video: "",
      form: {
        storyContent: "",
        videoTitle: "",
        video: "",
      },
      editorConfig: {language: 'de',scayt_sLang : 'de_DE'},
    };
  },
  methods: {
    appendFormData(file, xhr, formData) {
      formData.append("old_video", this.old_video);
    },
    videoUploadSuccess(){
    },
    dropzoneFileRemoved() {
      this.totaluploadprogress = 0;
      this.form.video = "";
    },
    videoUploadProgress(totaluploadprogress, totalBytes, totalBytesSent) {
      this.totaluploadprogress = totaluploadprogress;
    },
    editAboutContent() {
      adminAPI
        .editAboutContent()
        .then((response) => {
          if (response.status == "success") {
            this.form.storyContent = response.data.story_description;
            this.form.videoTitle = response.data.video_title;
            this.old_video = response.data.video_path;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.btnDisable = false;
            this.submitText = "Submit";
            this.$notify({
              group: "about",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.btnDisable = false;
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.submitText = "Submit";
          this.$notify({
            group: "about",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
    handleCancel() {
      // this.$router.push({ path: "/admin/dashboard" });
      this.totaluploadprogress = 0;
      this.$refs.aboutVideoUpload.removeFile(this.form.video);
      this.btnDisable = false;
      this.submitText = "Submit";
    },

    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.form.video = file;
        }
      }, 1000);
    },

    onSubmit() {
      this.$refs.aboutContentForm.validate().then((success) => {
        if (success && this.form.video !== null) {
          this.btnDisable = true;
          this.submitText = "Submitting...";
          this.$refs.aboutVideoUpload.processQueue();
          let fd = new FormData();
          fd.append("storytime", this.form.storyContent);
          fd.append("video_title", this.form.videoTitle);
          fd.append("video", this.form.video);
          fd.append("old_video", this.old_video);
          setTimeout(() => {
            adminAPI
              .addAboutContent(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.btnDisable = false;
                  this.submitText = "Submit";
                  this.totaluploadprogress = 0;
                  this.$refs.aboutVideoUpload.removeFile(this.form.video);
                  this.form.video = "";
                  this.$notify({
                    group: "about",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  // show page loading
                  this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                  this.editAboutContent();
                } else {
                  this.btnDisable = false;
                  this.submitText = "Submit";
                  this.totaluploadprogress = 0;
                  this.$notify({
                    group: "about",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Submit";
                this.totaluploadprogress = 0;
                this.$notify({
                  group: "about",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Submit";
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
